import {RouterModule} from '@angular/router';
import {HomeComponent} from './home.component';
import { SwitchClinicComponent } from './switch-clinic/switch-clinic.component';
import { AuthGuard } from '../core/auth.guard';

export const HomeRoutesModule = RouterModule.forChild([
    {path: '', component: HomeComponent},
]);
